import { useEffect } from "react"
import PropTypes from "prop-types"
import { useResolvedPath } from "react-router-dom"
import Loading from "components/loading"
import Error from "components/error"
import { ERROR, LOADING, OK } from "helpers/data-statuses"
import RedirectWithParams from "./redirectWithParams"
import { useReadContextPreference } from "hooks/preferences"
import { useLastPreferenceRedirect } from "resources/preferences"

export default function PreferenceRedirect({ preferenceSubType, defaultRedirect }) {
  const [preferredView, preferenceStatus] = useReadContextPreference(preferenceSubType, defaultRedirect)
  const { setLastPreferenceRedirect } = useLastPreferenceRedirect()

  const { pathname: redirectedTo } = useResolvedPath(preferredView)
  const { pathname: defaultRedirectTo } = useResolvedPath(defaultRedirect)

  const isDefaultRedirect = preferredView === defaultRedirect

  useEffect(() => {
    if (preferenceStatus === OK && !isDefaultRedirect) {
      setLastPreferenceRedirect(preferenceSubType, redirectedTo, defaultRedirectTo)
    }
  }, [setLastPreferenceRedirect, preferenceSubType, redirectedTo, defaultRedirectTo, preferenceStatus, isDefaultRedirect])

  if (preferenceStatus === ERROR) {
    return <Error />
  }

  if (preferenceStatus === LOADING) {
    return <Loading />
  }

  return <RedirectWithParams to={preferredView} replace />
}

PreferenceRedirect.propTypes = {
  preferenceSubType: PropTypes.string.isRequired,
  defaultRedirect: PropTypes.string.isRequired,
}
